import { Routes } from '@angular/router';
import { loggedInGuard } from './core/guards/logged-in/logged-in.guard';
import { loggedOutGuard } from './core/guards/logged-out/logged-out.guard';
import { AuthComponent } from './pages/auth/auth/auth.component';
import { BaseComponent } from './pages/base/base.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ProgramsDetailsComponent } from './pages/programs/programs-details/programs-details.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { CourseSectionDetailsComponent } from './pages/course-sections/course-section-details/course-section-details.component';
import { NqfDescriptorsComponent } from './pages/qualifications-framework-descriptors/nqf-descriptors.component';
import { CourseDetailsComponent } from './pages/courses/course-details/course-details.component';
import { ProgramsReportComponent } from './pages/programs/programs-report/programs-report.component';
import { ProgressReportsComponent } from './pages/progress-reports/progress-reports/progress-reports.component';

export const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    canActivate: [loggedInGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'redirect-system',

        loadComponent: () =>
          import('./pages/redirect-system/redirect-system.component').then(
            (m) => m.RedirectSystemComponent
          ),
      },

      {
        path: 'graduate-attributes',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './pages/graduate-attributes/all-graduate-attributes/all-graduate-attributes.component'
              ).then((m) => m.AllGraduateAttributesComponent),
          },
          {
            path: 'report',
            loadComponent: () =>
              import(
                './pages/graduate-attributes/report/report.component'
              ).then((m) => m.ReportComponent),
          },

          {
            path: '**',
            loadComponent: () =>
              import(
                './pages/graduate-attributes/all-graduate-attributes/all-graduate-attributes.component'
              ).then((m) => m.AllGraduateAttributesComponent),
          },
        ],
      },
      {
        path: 'evaluation-criteria',
        title: 'Evaluation Criteria',
        loadComponent: () =>
          import(
            './pages/evaluation-criteria/evaluation-criteria.component'
          ).then((m) => m.EvaluationCriteriaComponent),
      },
      {
        path: 'progress-reports',
        title: 'Progress Reports',
        component: ProgressReportsComponent,
        children: [
          { path: '', redirectTo: 'courses-clos', pathMatch: 'full' },
          {
            path: 'courses-clos',
            loadComponent: () =>
              import(
                './pages/progress-reports/courses-clos/courses-clos.component'
              ).then((m) => m.CoursesClosComponent),
          },
          {
            path: 'course-sections-progress',
            loadComponent: () =>
              import(
                './pages/progress-reports/course-sections-progress/course-sections-progress.component'
              ).then((m) => m.CourseSectionsProgressComponent),
          },
        ],
      },

      {
        path: 'national-qualifications-framework-descriptors',
        component: NqfDescriptorsComponent,
        children: [
          { path: '', redirectTo: 'national', pathMatch: 'full' },
          {
            path: 'national-report',
            loadComponent: () =>
              import(
                './pages/qualifications-framework-descriptors/reports/nqf-report/nqf-report.component'
              ).then((m) => m.NqfReportComponent),
          },
          {
            path: 'client-report',
            loadComponent: () =>
              import(
                './pages/qualifications-framework-descriptors/reports/cqf-report/cqf-report.component'
              ).then((m) => m.CqfReportComponent),
          },
          {
            path: 'national',
            loadComponent: () =>
              import(
                './pages/qualifications-framework-descriptors/national-qualifications-framework-descriptors/national-qualifications-framework-descriptors.component'
              ).then(
                (m) => m.NationalQualificationsFrameworkDescriptorsComponent
              ),
          },
          {
            path: 'client',
            loadComponent: () =>
              import(
                './pages/qualifications-framework-descriptors/client-national-qualifications-framework-descriptors/client-qualifications-framework-descriptors.component'
              ).then(
                (m) => m.ClientQualificationsFrameworkDescriptorsComponent
              ),
          },
        ],
      },

      {
        path: 'programs',
        title: 'Programs',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './pages/programs/all-programs/all-programs.component'
              ).then((m) => m.AllProgramsComponent),
          },
          {
            path: 'report/:programID',
            component: ProgramsReportComponent,
            children: [
              {
                path: 'aol-report',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-report/report/report.component'
                  ).then((m) => m.ReportComponent),
              },
              {
                path: 'course-outlier',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-report/course-outlier/course-outlier.component'
                  ).then((m) => m.CourseOutlierComponent),
              },
              {
                path: 'courses-completions',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-report/courses-completions/courses-completions.component'
                  ).then((m) => m.CoursesCompletionsComponent),
              },
              {
                path: 'courses-clos',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-report/courses-clos/courses-clos.component'
                  ).then((m) => m.CoursesClosComponent),
              },
              {
                path: 'aol-report',
                redirectTo: 'aol-report',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: ':programID',
            component: ProgramsDetailsComponent,
            children: [
              {
                path: 'courses',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-details/program-courses/program-courses.component'
                  ).then((m) => m.ProgramCoursesComponent),
              },
              {
                path: 'students',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-details/program-students/program-students.component'
                  ).then((m) => m.ProgramStudentsComponent),
              },
              {
                path: 'plos',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-details/program-plos/program-plos.component'
                  ).then((m) => m.ProgramPlosComponent),
              },
              {
                path: 'competencies',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-details/program-competencies/program-competencies.component'
                  ).then((m) => m.ProgramCompetenciesComponent),
              },
              {
                path: 'goals',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-details/program-goals/program-goals.component'
                  ).then((m) => m.ProgramGoalsComponent),
              },
              {
                path: 'evaluation-criteria',
                loadComponent: () =>
                  import(
                    './pages/programs/programs-details/program-evaluation-criteria/program-evaluation-criteria.component'
                  ).then((m) => m.ProgramEvaluationCriteriaComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'courses',
        title: 'Courses',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/courses/all-courses/all-courses.component').then(
                (m) => m.AllCoursesComponent
              ),
          },
          {
            path: 'aol/:courseID',
            component: CourseDetailsComponent,
            children: [
              {
                path: 'corrective-actions',
                loadComponent: () =>
                  import(
                    './pages/courses/course-details/courses-corrective-actions/courses-corrective-actions.component'
                  ).then((m) => m.CoursesCorrectiveActionsComponent),
              },
              {
                path: 'reports',
                loadComponent: () =>
                  import(
                    './pages/courses/course-details/course-report/course-report.component'
                  ).then((m) => m.CourseReportComponent),
              },
              {
                path: '',
                redirectTo: 'reports',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: ':courseID',

            children: [
              {
                path: 'clos',
                loadComponent: () =>
                  import(
                    './pages/courses/course-clos/course-clos.component'
                  ).then((m) => m.CourseClosComponent),
              },

              {
                path: 'sections',
                loadComponent: () =>
                  import(
                    './pages/course-sections/course-sections-for-course/course-sections-for-course.component'
                  ).then((m) => m.CourseSectionsForCourseComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'course-sections',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './pages/course-sections/all-course-sections/all-course-sections.component'
              ).then((m) => m.AllCourseSectionsComponent),
          },
          {
            path: ':courseSectionID/aol',
            component: CourseSectionDetailsComponent,
            children: [
              {
                path: 'corrective-actions',
                loadComponent: () =>
                  import(
                    './pages/course-sections/course-section-details/course-section-corrective-actions/course-section-corrective-actions.component'
                  ).then((m) => m.CourseSectionCorrectiveActionsComponent),
              },
              {
                path: 'outlier-justification',
                loadComponent: () =>
                  import(
                    './pages/course-sections/course-section-details/outlier-justification/outlier-justification.component'
                  ).then((m) => m.OutlierJustificationComponent),
              },
              {
                path: 'report',
                loadComponent: () =>
                  import(
                    './pages/course-sections/course-section-details/course-section-report/course-section-report.component'
                  ).then((m) => m.CourseSectionReportComponent),
              },

              {
                path: '',
                redirectTo: 'report',
                pathMatch: 'full',
              },
            ],
          },
        ],
      },
      {
        path: 'activities',
        children: [
          {
            path: 'course-sections/:courseSectionID',
            loadComponent: () =>
              import(
                './pages/activities/course-section-activities/course-section-activities.component'
              ).then((m) => m.CourseSectionActivitiesComponent),
          },
          {
            path: ':activityID/grades',
            loadComponent: () =>
              import(
                './pages/activities/activity-grades/activity-grades.component'
              ).then((m) => m.ActivityGradesComponent),
          },
          {
            path: ':activityID/questions',
            loadComponent: () =>
              import(
                './pages/activities/activity-questions/activity-questions.component'
              ).then((m) => m.ActivityQuestionsComponent),
          },
          {
            path: ':activityID/aol',

            loadComponent: () =>
              import('./pages/activities/reports/reports.component').then(
                (m) => m.ReportsComponent
              ),
          },
        ],
      },
      {
        path: 'students',
        title: 'Students',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './pages/students/all-students/all-students.component'
              ).then((m) => m.AllStudentsComponent),
          },
          {
            path: 'course-sections/:courseSectionID',
            loadComponent: () =>
              import(
                './pages/students/course-section-students/course-section-students.component'
              ).then((m) => m.CourseSectionStudentsComponent),
          },
        ],
      },
      {
        path: 'settings',
        title: 'Settings',
        children: [
          {
            path: '',
            component: SettingsComponent,
            children: [
              {
                path: 'change-password',
                loadComponent: () =>
                  import(
                    './pages/settings/change-password/change-password.component'
                  ).then((m) => m.ChangePasswordComponent),
              },
            ],
          },
        ],
      },

      {
        path: 'course-sections',
        title: 'Course Sections',
        loadComponent: () =>
          import('./pages/courses/all-courses/all-courses.component').then(
            (m) => m.AllCoursesComponent
          ),
      },
      {
        path: 'course-sections-reviews',
        children: [
          {
            path: '',
            title: 'Course Sections Review',
            loadComponent: () =>
              import(
                './pages/course-sections-reviews/all-course-sections-reviews/all-course-sections-reviews.component'
              ).then((m) => m.AllCourseSectionsReviewsComponent),
          },
          {
            path: ':courseSectionID',
            loadComponent: () =>
              import(
                './pages/course-sections-reviews/course-section-review-details/course-section-review-details.component'
              ).then((m) => m.CourseSectionReviewDetailsComponent),
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    component: AuthComponent,
    canActivate: [loggedOutGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
      },
      {
        path: 'first-time-login',
        loadComponent: () =>
          import(
            './pages/auth/first-time-login/first-time-login.component'
          ).then((m) => m.FirstTimeLoginComponent),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          ),
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('./pages/auth/forget-password/forget-password.component').then(
            (m) => m.ForgetPasswordComponent
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
    ],
  },

  { path: '**', component: PageNotFoundComponent },
];
